/** Каталог якорей модуля «Предложения по улучшению» */
export const IMPROVEMENTS_ANCHORS = {
  /** Шестерёнка настроек модуля у пункта «Предложения по улучшению» в боковом меню */
  nav: {
    settings: 'improvements.nav.settings',
  },
  feed: {
    create: 'improvements.feed.create',
    settings: 'improvements.feed.settings',
    registry: 'improvements.feed.registry',
    rating: 'improvements.feed.rating',
    requiresAction: 'improvements.feed.requiresAction',
    filter: 'improvements.feed.filter',
    demoCard: 'improvements.feed.demoCard',
  },
  create: {
    type: 'improvements.create.type',
    anonymous: 'improvements.create.anonymous',
  },
  settings: {
    expertsTab: 'improvements.settings.expertsTab',
    typesTab: 'improvements.settings.typesTab',
    addExpert: 'improvements.settings.addExpert',
    /** Карточка вкладки «Эксперты»: кнопка добавления и таблица экспертов */
    expertsPanel: 'improvements.settings.expertsPanel',
    createType: 'improvements.settings.createType',
  },
  registry: {
    search: 'improvements.registry.search',
    requiresAction: 'improvements.registry.requiresAction',
    resetFilters: 'improvements.registry.resetFilters',
    filterPrefix: 'improvements.registry.filter.',
    filterFirst: 'improvements.registry.filter.suggestion_type',
    filterLast: 'improvements.registry.filter.stage',
    demoRow: 'improvements.registry.demoRow',
  },
  rating: {
    table: 'improvements.rating.table',
  },
  form: {
    type: 'improvements.form.type',
    decision: 'improvements.form.decision',
    reviewTab: 'improvements.form.reviewTab',
    chair: 'improvements.form.chair',
    assignExperts: 'improvements.form.assignExperts',
    /** Таблица экспертов комиссии с их голосами на вкладке «Рассмотрение» */
    experts: 'improvements.form.experts',
    actions: 'improvements.form.actions',
    vote: 'improvements.form.vote',
    historyTab: 'improvements.form.historyTab',
  },
} as const

export const IMPROVEMENTS_CONTEXTS = {
  feed: 'improvements.feed',
  registry: 'improvements.registry',
  settings: 'improvements.settings',
  rating: 'improvements.rating',
  form: 'improvements.form',
  formTasks: 'improvements.form.tasks',
} as const
